import { render, staticRenderFns } from "./CustomChartLegend.vue?vue&type=template&id=9abcc3cc&scoped=true&"
import script from "./CustomChartLegend.vue?vue&type=script&lang=js&"
export * from "./CustomChartLegend.vue?vue&type=script&lang=js&"
import style0 from "./CustomChartLegend.vue?vue&type=style&index=0&id=9abcc3cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9abcc3cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VIcon,VRow,VTooltip})
